import { Stack, Typography } from "@mui/material";
import { isEmptyObject } from "@entrilia/shared/utilities/objectHelper";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";
import PageViewsChart from "./PageViewsChart";

interface Props {
  row: DocumentViews;
}

const DocumentViewsGridRowDetail = ({ row }: Props) => {
  if (isEmptyObject(row.pageViews)) {
    return null;
  }

  const title = row.totalDurationOfVideoFile ? "Time spent per segment" : "Time spent per page";

  return (
    <Stack sx={{ px: 4, pb: 3, height: "100%" }}>
      <Typography variant="subtitle2" sx={{ pt: 2 }}>
        {title}
      </Typography>
      <PageViewsChart pageViews={row.pageViews} totalDurationOfVideoFile={row.totalDurationOfVideoFile} />
    </Stack>
  );
};

export default DocumentViewsGridRowDetail;
